import {
    DEALERPENDINGREQUESTLIST_SUCCESS,
    DEALERPENDINGREQUESTLIST_FAILED,
    RESET_DEALERPENDINGREQUESTLIST,
    LOADING_DEALERPENDINGREQUESTLIST,
    NETWORK_ERROR_DEALERPENDINGREQUESTLIST
} from '../types/index'


const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERPENDINGREQUESTLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERPENDINGREQUESTLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERPENDINGREQUESTLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERPENDINGREQUESTLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERPENDINGREQUESTLIST:
            return (state = initialState);
        default:
            return state;
    }
};